import { Layout } from "@/components/layout/Layout";
import { PageHero } from "@/components/shared/PageHero";
import { AnimatedSection } from "@/components/shared/AnimatedSection";
import { CTASection } from "@/components/shared/CTASection";
import { SERVICES_DETAILED } from "@/data/siteData";
import * as Icons from "@phosphor-icons/react";

const HERO_IMAGE =
  "https://images.unsplash.com/photo-1571260899304-425eee4c7efc?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600";

export default function Services() {
  return (
    <Layout
      title="Services | Mithra Jobs"
      description="Teacher recruitment solutions for schools, including candidate sourcing, screening, shortlisting, interview coordination and ongoing recruitment support."
    >
      <PageHero
        label="Services"
        heading="Teacher Recruitment Solutions for Schools"
        description="From understanding a school's requirement to coordinating interviews, Mithra Jobs supports every step of the teacher recruitment journey."
        image={HERO_IMAGE}
        imageAlt="Teacher presenting to a classroom"
      />

      <section className="py-24 px-6 bg-cream">
        <div className="max-w-7xl mx-auto space-y-20">
          {SERVICES_DETAILED.map((service, i) => {
            const Icon = Icons[service.icon];
            const reverse = i % 2 === 1;
            return (
              <div
                key={service.title}
                className={`grid lg:grid-cols-2 gap-12 items-start ${
                  reverse ? "lg:[&>div:first-child]:order-2" : ""
                }`}
              >
                <AnimatedSection data-testid={`service-detail-${i + 1}`}>
                  <span className="font-heading text-sm text-accent tracking-[0.2em] uppercase">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div className="w-14 h-14 rounded-xl bg-navy/5 flex items-center justify-center my-5">
                    <Icon size={26} weight="duotone" className="text-navy" />
                  </div>
                  <h2 className="font-heading text-2xl sm:text-3xl font-semibold text-navy tracking-tight mb-4">
                    {service.title}
                  </h2>
                  <p className="text-slate leading-relaxed">{service.description}</p>
                  {service.points && (
                    <ul className="mt-5 grid grid-cols-2 gap-3">
                      {service.points.map((p) => (
                        <li key={p} className="flex items-center gap-2 text-sm text-navy/80">
                          <span className="w-1.5 h-1.5 rounded-full bg-accent" />
                          {p}
                        </li>
                      ))}
                    </ul>
                  )}
                </AnimatedSection>
                <AnimatedSection
                  delay={0.1}
                  className="border border-navy/10 rounded-2xl bg-white p-10 h-full flex items-center min-h-[220px]"
                >
                  <p className="font-heading text-xl italic text-navy/25 leading-snug">{service.tagline}</p>
                </AnimatedSection>
              </div>
            );
          })}
        </div>
      </section>

      <CTASection
        heading="Have a Teaching Requirement?"
        description="Share your requirement with our recruitment team and we will help you identify suitable teaching professionals."
        primaryLabel="Talk to Mithra Jobs"
        primaryTo="/contact-us"
        testIdPrefix="services-cta"
      />
    </Layout>
  );
}
